import { render, staticRenderFns } from "./RichTextDisplay.vue?vue&type=template&id=5c2eca11&scoped=true"
import script from "./RichTextDisplay.vue?vue&type=script&lang=ts"
export * from "./RichTextDisplay.vue?vue&type=script&lang=ts"
import style0 from "./RichTextDisplay.vue?vue&type=style&index=0&lang=scss"
import style1 from "./RichTextDisplay.vue?vue&type=style&index=1&id=5c2eca11&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2eca11",
  null
  
)

export default component.exports